import React from 'react';

export default function Montageanleitung() {
  return <div>??????????</div>;
}
